import React, { useEffect, useState } from "react";
import { PieChart } from "../Components/PieChart";
import { KeyedValue } from "Components";
import {
  PresaveReleaseStatus,
  ReleasePresave,
} from "@max/common/dist/artists/presave";
import { setbioColors, setfanColors, Source } from "../types";

const STATUSES = ["delivered", "pending", "failed"] as const;
type Status = (typeof STATUSES)[number];

interface Props {
  preSaves: ReleasePresave[];
  releaseId?: string;
  source?: Source;
}

export const StatusChart: React.FC<Props> = ({
  releaseId,
  preSaves,
  source,
}) => {
  const [data, setData] = useState<KeyedValue[]>([]);

  const getData = () => {
    const statusLabels: Record<Status, string> = {
      delivered: "Delivered",
      pending: "Pending",
      failed: "Failed",
    };

    const statusMap: Record<Status, PresaveReleaseStatus[]> = {
      delivered: ["success"],
      pending: ["scheduled", "pending"],
      failed: ["fail"],
    };

    const preSavesByStatus: Record<Status, number> = {
      delivered: 0,
      pending: 0,
      failed: 0,
    };

    for (const preSave of preSaves) {
      const status = preSave.completedReleases[releaseId].status;
      let statusKey = Object.entries(statusMap).find(([_, values]) =>
        values.includes(status),
      )?.[0];
      if (statusKey) {
        preSavesByStatus[statusKey] += 1;
      }
    }

    return Object.entries(preSavesByStatus).map(([status, count]) => ({
      id: status,
      label: statusLabels[status],
      count: count,
    }));
  };

  useEffect(() => {
    const data = getData();
    setData(data);
  }, [preSaves.length]);

  return (
    <PieChart
      title="Pre-Save Status"
      data={data}
      colors={source === "setfan" ? setfanColors : setbioColors}
    />
  );
};
